<template>
    <section class="Section LoginSection">
        <img src="/images/CmsData/LoginBackground.jpg" alt=""/>
        <div class="BackgroundOverlay">
            <div class="LoginPanel">
                <div class="LoginLogo"><img src="/images/LoginLogo.png" srcset="/App_Skins/Sito/images/LoginLogoRetina.png 2x" alt=""/></div>
                <div class="Form">
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputText Artistic UserField">
                            <div class="Label">&nbsp;</div>
                            <div class="Field"><input v-model="this.email" placeholder="Insert your email" type="text" /></div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputButton">
                            <div class="Label RecoveryPassword">                                
                                <router-link :to="{'name' : 'Login'}">Back to Login</router-link>
                            </div>
                            <div class="Field Button"><input @click="this.recuperaPassword()" type="button" value="Password recovery"  /></div>
                        </div>
                    </div>
                    <div class="loader" v-show="isLoading"></div> 
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputButton">
                            <span class="errorMsg">{{errorMsg}}</span>
                        </div>
                        <div class="FormBoxWide FormInputButton">
                            {{ this.successMsg }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import AuthService from "@/services/auth.service.js";


export default {
    name: "RecuperoPassword",
    data(){
        return {
            email: "",
            isLoading: false,
            errorMsg: "",
            successMsg: ""
        }
    },
    watch:{
        email: function(newVal){
            if(newVal){
                this.errorMsg = "";
            }
        } 
    }, 
    methods: {
        recuperaPassword(){
            
            if(!this.email){
                this.errorMsg = "Email is required";
                return;
            }
            this.isLoading = true;
            AuthService.recuperoPassword(this.email).then(
               
                (data) => {
                    this.isLoading = false;

                    if(data.status == 200){
                        this.successMsg = "Password recovered successfully. An email has been sent to you with the new password";
                    }
                    else if(data.status == 400){
                        this.errorMsg = "The email entered is not present in our systems";
                    }
                    else{
                        this.errorMsg = "An error occurred while retrieving the password";
                    }
                }

            );

        }
    }

}
</script>

<style>
.errorMsg{
    color:#ff0000;
}
</style>